import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type PlayIconProps = Partial<SVGIconProps>;

const PlayIcon: FC<PlayIconProps> = (props) => (
  <SVGIcon {...props} fill="none" height="20" viewBox="0 0 20 20" width="20">
    <path
      d="M7.25 5.3C7.25 4.68753 7.90939 4.31363 8.43137 4.62153L14.494 8.0216C15.0117 8.32703 15.0117 9.07297 14.494 9.3784L8.43137 12.7785C7.90939 13.0864 7.25 12.7125 7.25 12.1V5.3Z"
      fill="#0D121C"
    />
  </SVGIcon>
);

export default PlayIcon;
